import type { AppDefinition, ComingApp } from '../types';

export const ALL_APPS: AppDefinition[] = [
  {
    id: 'adm',
    name: 'GS-Admin',
    desc: 'Utilisateurs, syncs SOFI, logs ETL',
    icon: 'Settings2',
    iconBg: '#eff6ff',
    iconColor: '#2563eb',
    platform: 'azure',
    status: 'dev',
    url: 'https://admin.groupesignalisation.ca',
    adminOnly: true,
  },
  {
    id: 'ug',
    name: 'Console UG',
    desc: 'Acces : identites, roles, scope multi-company',
    icon: 'KeyRound',
    iconBg: '#eff6ff',
    iconColor: '#2563eb',
    platform: 'azure',
    status: 'dev',
    url: 'https://ug.groupesignalisation.ca',
    adminOnly: true,
  },
  // GS-Inventaire DECOMMISSIONNEE 2026-06-05 (BLITZ-MASTER-INV-REMONTEE-DROP) : entree retiree du
  // catalogue hub. inv.Locations/UserServicePoints remontees dim/ug ; reste de inv droppe (Phase 5).
  // Recreation C-native = chantier separe (SPEC-2).
  // GS-Analytics RETIREE 2026-06-06 (BLITZ-MASTER-DECOMMISSION-GS-ANALYTICS) : BI pre-monorepo
  // (jamais une app du monorepo ; apps/analytics jamais construit). PAS de renaissance -- remplacee
  // par le medallion stg_sofi->silver->gold + analytics in-app. Faits legacy mig 141 :
  // fact.Factures / fact.Plans + adm.EtlControl (ex dbo.ANL_*). Retrait adm.Apps/SyncConfigs = STOP David db_owner.
  {
    id: 'ops',
    name: 'GS-Ops',
    desc: 'GPS, punch, bons de travail',
    icon: 'HardHat',
    iconBg: '#f0fdf4',
    iconColor: '#16a34a',
    platform: 'firebase', // platform a migrer vers azure post-ADR-052 (Phase 4 PWA terrain)
    status: 'test',
    url: '',
  },
  {
    id: 'shp',
    name: 'GS-ShopHub',
    desc: 'Facturation mécanique B2B',
    icon: 'Wrench',
    iconBg: '#fdf4ff',
    iconColor: '#a21caf',
    platform: 'azure',
    status: 'poc',
    url: '',
  },
  {
    id: 'for',
    name: 'GS-Formation',
    desc: 'LMS, certifications employés',
    icon: 'GraduationCap',
    iconBg: '#f5f3ff',
    iconColor: '#7c3aed',
    platform: 'firebase', // platform a migrer vers azure post-ADR-052 (Phase 4 PWA terrain)
    status: 'test',
    url: '',
  },
  {
    id: 'sst',
    name: 'GS-ZoneSecur',
    desc: 'SST, prévention, rapports terrain',
    icon: 'ShieldCheck',
    iconBg: '#ecfdf5',
    iconColor: '#059669',
    platform: 'firebase', // platform a migrer vers azure post-ADR-052 (Phase 4 PWA terrain)
    status: 'prod',
    url: '',
  },
  {
    id: 'flt',
    name: 'GS-Flotte',
    desc: 'Maintenance & TCO, 500 véhicules',
    icon: 'Truck',
    iconBg: '#fffbeb',
    iconColor: '#d97706',
    platform: 'azure',
    status: 'dev',
    url: '',
  },
  {
    id: 'iot',
    name: 'UF WebEditor',
    desc: 'Config AFAD, IoT, firmware OTA',
    icon: 'Cpu',
    iconBg: '#fff8ed',
    iconColor: '#F99D27', // ds-lint-exempt: accent produit WebEditor (donnée de tuile, pas du styling de marque)
    platform: 'firebase', // ADR-052: reste firebase, IoT firmware Arduino REST Firestore (~80 devices OPTA en prod), isole intentionnel
    status: 'prod',
    url: '',
  },
  {
    id: 'dep',
    name: 'GS-Dépenses',
    desc: 'Notes de frais & approbation',
    icon: 'Receipt',
    iconBg: '#fdf2f8',
    iconColor: '#c026d3',
    platform: 'azure',
    status: 'poc',
    url: '',
  },
  {
    id: 'sal',
    name: 'GS-Salus',
    desc: 'Inspections SST & risques EPI',
    icon: 'HeartPulse',
    iconBg: '#fef2f2',
    iconColor: '#dc2626',
    platform: 'firebase', // platform a migrer vers azure post-ADR-052 (Phase 4 PWA terrain)
    status: 'dev',
    url: '',
  },

  // ─── Zone Espace GS (apps fun pour les employés) ───────────────
  {
    id: 'rec',
    name: 'GS-Recettes',
    desc: 'Partage de recettes entre collègues',
    icon: 'ChefHat',
    iconBg: '#fff7ed',
    iconColor: '#ea580c',
    platform: 'azure',
    status: 'poc',
    url: '',
    zone: 'fun',
  },
  {
    id: 'trv',
    name: 'GS-Trivia',
    desc: 'Quiz & connaissances GS',
    icon: 'Brain',
    iconBg: '#eff6ff',
    iconColor: '#2563eb',
    platform: 'azure',
    status: 'poc',
    url: '',
    zone: 'fun',
  },
  {
    id: 'pls',
    name: 'GS-Playlist',
    desc: 'Musique partagée au bureau',
    icon: 'Music2',
    iconBg: '#f5f3ff',
    iconColor: '#7c3aed',
    platform: 'azure',
    status: 'poc',
    url: '',
    zone: 'fun',
  },
];

export const COMING_APPS: ComingApp[] = [
  { id: 'rcr', name: 'GS-Recrutement', desc: 'Remplace Appy Here' },
  { id: 'tkt', name: 'GS-Tickets', desc: 'Bugs et améliorations' },
];

export function getAppById(id: string): AppDefinition | undefined {
  return ALL_APPS.find((a) => a.id === id);
}
